// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1OAuthTokenRequestSchema } from './v1/oAuth/tokenRequestSchema';
import { v1OAuthTokenResponseSchema } from './v1/oAuth/tokenResponseSchema';

/**
 * @description access token created
 */
export const createAccessToken200Schema = z.lazy(() => v1OAuthTokenResponseSchema);

/**
 * @description invalid request
 */
export const createAccessToken400Schema = z.object({
  error: z.optional(z.coerce.string()),
  error_description: z.optional(z.coerce.string()),
});

export const createAccessTokenMutationRequestSchema = z.lazy(() => v1OAuthTokenRequestSchema);

export const createAccessTokenMutationResponseSchema = z.lazy(() => createAccessToken200Schema);
